module.exports = __webpack_public_path__ + "img/avatar-08.C5aKY-jV.dfb41ac3.jpg";